<template>
  <div class="section-error p-3 rounded" :class="variantClass">
    <div class="d-flex align-items-start">
      <feather-icon :icon="icon" size="20" class="mr-2 flex-shrink-0 mt-1" />
      <div class="flex-grow-1">
        <p class="mb-1 font-weight-bold">{{ title }}</p>
        <p class="mb-2 text-sm" v-if="error.message">
          {{ error.message }}
        </p>

        <div class="text-sm text-muted" v-if="showDetails">
          <div v-if="error.source">
            <strong>Source:</strong> {{ error.source }}
          </div>
          <div v-if="error.responsible_team">
            <strong>Contact:</strong> {{ error.responsible_team }}
          </div>
        </div>

        <!-- Technical Details (collapsible) -->
        <div v-if="error.technical_error" class="mt-2">
          <b-button
            variant="link"
            size="sm"
            class="p-0 text-muted"
            @click="showTechnical = !showTechnical"
          >
            <feather-icon
              :icon="showTechnical ? 'ChevronUpIcon' : 'ChevronDownIcon'"
              size="14"
              class="mr-1"
            />
            Technical Details
          </b-button>
          <b-collapse v-model="showTechnical">
            <div
              class="bg-dark text-light p-2 rounded mt-2 text-sm"
              style="font-family: monospace"
            >
              <div v-if="error.connection_name">
                <span class="text-warning">Connection:</span>
                {{ error.connection_name }}
              </div>
              <div v-if="error.table_or_view">
                <span class="text-warning">Table/View:</span>
                {{ error.table_or_view }}
              </div>
              <div class="text-danger mt-1">
                {{ error.technical_error }}
              </div>
            </div>
          </b-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BButton, BCollapse } from "bootstrap-vue";

export default {
  name: "SectionError",
  components: {
    BButton,
    BCollapse,
  },
  props: {
    error: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: "Failed to load data",
    },
    variant: {
      type: String,
      default: "warning", // warning, danger, info
    },
    showDetails: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showTechnical: false,
    };
  },
  computed: {
    variantClass() {
      const classes = {
        warning: "bg-light-warning border-warning",
        danger: "bg-light-danger border-danger",
        info: "bg-light-info border-info",
      };
      return classes[this.variant] || classes.warning;
    },
    icon() {
      const icons = {
        warning: "AlertTriangleIcon",
        danger: "AlertCircleIcon",
        info: "InfoIcon",
      };
      return icons[this.variant] || icons.warning;
    },
  },
};
</script>

<style scoped>
.section-error {
  border-left: 4px solid;
}

.text-sm {
  font-size: 0.875rem;
}

.bg-light-warning {
  background-color: rgba(255, 159, 67, 0.12);
}

.bg-light-danger {
  background-color: rgba(234, 84, 85, 0.12);
}

.bg-light-info {
  background-color: rgba(0, 207, 232, 0.12);
}

.border-warning {
  border-color: #ff9f43 !important;
}

.border-danger {
  border-color: #ea5455 !important;
}

.border-info {
  border-color: #00cfe8 !important;
}
</style>
